export function isSquare(matrix: number[][]): boolean {
  return matrix.length === matrix[0]!.length
}
